import React from 'react'
import { withRedirectUrl } from '@ztechapps/common.utils'
import { Link } from '@ztechapps/webui.util'
import { useContext } from './Context'

export const GoogleAuthLayout = () => {
  const { redirectUrl } = useContext()

  return <Link href={withRedirectUrl('/api/auth/google/pp-store', redirectUrl)}>With Google Login </Link>
}
